<template>
  <!-- Authors Table Card -->
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ padding: 0 }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="12">
            <h5 class="font-semibold m-0">落地页管理</h5>
          </a-col>
          <a-col
            :span="24"
            :md="12"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-button type="primary" class="add-shop" @click="() => (modal2Visible = true)" size="small"> 新增落地页 </a-button>
            <a-radio-group v-model="authorsHeaderBtns" size="small">
              <a-radio-button value="all">已上线</a-radio-button>
              <a-radio-button value="online">部署中</a-radio-button>
            </a-radio-group>
          </a-col>
        </a-row>
      </template>
      <a-table :columns="columns" :data-source="data" :pagination="false">
        <template slot="author" slot-scope="author">
          <div class="table-avatar-info">
            <a-avatar shape="square" :src="author.avatar" />
            <div class="avatar-info">
              <h6>{{ author.name }}</h6>
              <p>{{ author.email }}</p>
            </div>
          </div>
        </template>
        <template slot="website" slot-scope="website">
          <div class="author-info">
            <h6 class="m-0">{{ website }}</h6>
          </div>
        </template>
        <template slot="func" slot-scope="func">
          <div class="author-info">
            <h6 class="m-0">{{ func.job }}</h6>
            <p class="m-0 font-regular text-muted">{{ func.department }}</p>
          </div>
        </template>

        <template slot="status" slot-scope="status">
          <a-tag
            class="tag-status"
            :class="status ? 'ant-tag-primary' : 'ant-tag-muted'"
          >
            {{ status ? "有效" : "失效" }}
          </a-tag>
        </template>

        <template slot="editBtn" slot-scope="row">
          <div style="white-space: pre">
            <a-button type="link" :data-id="row.key" class="btn-edit">
              编辑
            </a-button>
            <a-button type="link" :data-id="row.key" icon="btn-edit">
              刷新<a-icon type="retweet" />
            </a-button>
          </div>
        </template>
      </a-table>
      <!-- Pagination -->
      <a-pagination
        :current="currentPage"
        :total="data.length"
        :pageSize="pageSize"
        @change="handlePageChange"
        class="pagination"
      />
    </a-card>
    <a-modal
      v-model="modal2Visible"
      title="新增落地页"
      centered
      @ok="() => (modal2Visible = false)"
    >
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">

    <a-form-model-item label="服务器">
      <a-select v-model="form.name" placeholder="please select your zone">
        <a-select-option value="shanghai">
          Zone one
        </a-select-option>
        <a-select-option value="beijing">
          Zone two
        </a-select-option>
      </a-select>
    </a-form-model-item>
        <a-form-model-item ref="name" label="域名" prop="password">
      <a-input
        v-model="form.password"
        @blur="
          () => {
            $refs.name.onFieldBlur();
          }
        "
      />
    </a-form-model-item>
    <a-form-model-item label="到期时间">
      <a-date-picker
        v-model="form.date1"
        show-time
        type="date"
        placeholder="Pick a date"
        style="width: 100%;"
      />
    </a-form-model-item>
  </a-form-model>
    </a-modal>
  </div>

  <!-- / Authors Table Card -->
</template>

<script>
// import {shoplist} from "@/api/shop"
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  created(){
    this.getAllShopNames()
  },
  data() {
    return {
      // Active button for the "Authors" table's card header radio button group.
      authorsHeaderBtns: "all",
      // Pagination data
      currentPage: 1,
      pageSize: 10,
      modal2Visible: false,
      form: {
        name: '',
        date1: undefined,
        password:"",
      }
    };
  },
  computed: {
    // Compute the data to display based on current page and page size
    displayData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.data.slice(startIndex, endIndex);
    },
  },
  methods: {
    // Handle page change
    handlePageChange(page) {
      this.currentPage = page;
    },
    setModal1Visible(modal1Visible) {
      this.modal1Visible = modal1Visible;
    },
    getAllShopNames(){
      // shoplist().then(res=>{
      //   console.log(res)
      // })
    }
  },
};
</script>
